function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1381_1000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.94394 4.22996C10.8851 3.99863 12.8486 4.40897 14.5347 5.39833C16.2207 6.38769 17.5366 7.90169 18.2814 9.70913C18.3509 9.89622 18.3509 10.102 18.2814 10.2891C17.9752 11.0316 17.5704 11.7295 17.0781 12.3641M11.7364 11.7983C11.2649 12.2537 10.6334 12.5057 9.97793 12.5C9.32244 12.4943 8.69541 12.2314 8.23189 11.7678C7.76837 11.3043 7.50545 10.6773 7.49975 10.0218C7.49406 9.3663 7.74604 8.7348 8.20144 8.26329M14.5656 14.5825C13.4602 15.2373 12.2268 15.6466 10.9492 15.7828C9.67165 15.9189 8.37973 15.7787 7.16113 15.3715C5.94253 14.9644 4.82576 14.2999 3.88661 13.4231C2.94746 12.5463 2.2079 11.4778 1.7181 10.29C1.64865 10.1029 1.64865 9.89706 1.7181 9.70996C2.45696 7.91817 3.757 6.41433 5.4231 5.42413M1.66644 1.66663L18.3331 18.3333",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1381_1000"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgEyeHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.6ec5d347.svg";
export { ForwardRef as ReactComponent };